import {Typography} from "@mui/material";
import type {BasePlaces} from "../../firebase/index.js";
import type {ItineraryPlannedProps} from "./ItineraryPlanned.jsx";
import ItinerarySummaryLayout from "./ItinerarySummaryLayout.jsx";


export default function ItinerarySummary({plannedPlaces}: ItineraryPlannedProps) {
	  return (
				 <>
						{
								  Object.keys(plannedPlaces).length === 0 &&
								  <Typography variant="h4" sx={{textAlign: "center", marginTop: 4}}>Set dates first to see a summary</Typography>
						}
						{
								  Object.keys(plannedPlaces).length > 0 &&
								  Object.keys(plannedPlaces).map((dateKey) => {
										 const basePlaces: BasePlaces = plannedPlaces[dateKey];
										 return <ItinerarySummaryLayout key={dateKey} dateKey={dateKey} basePlaces={basePlaces}/>;
								  })
						}
				 </>
	  );
}